export const tuple = (...args) => args;
// case insensitive Map
export class IMap extends Map {
  constructor(iterable) {
    super();
    this.keysMap = new Map();
    if (iterable) {
      for (const [key, value] of iterable) {
        this.set(key, value);
      }
    }
  }
  set(key, value) {
    const keyLowerCase = typeof key === 'string'
      ? key.toLowerCase()
      : key;
    this.keysMap.set(keyLowerCase, key);
    return super.set(keyLowerCase, value);
  }
  get(key) {
    return typeof key === 'string'
      ? super.get(key.toLowerCase())
      : super.get(key);
  }
  has(key) {
    return typeof key === 'string'
      ? super.has(key.toLowerCase())
      : super.has(key);
  }
  delete(key) {
    const keyLowerCase = typeof key === 'string'
      ? key.toLowerCase()
      : key;
    this.keysMap.delete(keyLowerCase);
    return super.delete(keyLowerCase);
  }
  clear() {
    this.keysMap.clear();
    super.clear();
  }
  keys() {
    return this.keysMap.values();
  }
  *entries() {
    const keys = this.keysMap.values();
    const values = super.values();
    for (let i = 0; i < super.size; i++) {
      yield [keys.next().value, values.next().value];
    }
  }
  forEach(callbackfn) {
    const keys = this.keysMap.values();
    const values = super.values();
    for (let i = 0; i < super.size; i++) {
      callbackfn(values.next().value, keys.next().value, this);
    }
  }
  [Symbol.iterator]() {
    return this.entries();
  }
}
;
